import React from "react";
import { invoiceStatus, getInvoiceStatusName } from "../../../utils/GlobalData";

export default function InvoiceStatus(props) {
  const changeClassByStatus = {
    [invoiceStatus.PAID.value]: "txt-success",
    [invoiceStatus.PENDING.value]: "txt-warning",
    [invoiceStatus.OVERDUE.value]: "txt-error",
  };

  return (
    <h6
      className={`mb-0 p-0 bg-transparent text-capitalize  ${
        changeClassByStatus[props.status] || ""
      }`}
      style={{ fontSize: "0.9rem" }}
    >
      {getInvoiceStatusName[props.status] || props.status}
    </h6>
  );
}
